import { Form, Input, Switch, Select, Row, Col, InputNumber } from 'antd';
import { useRef, useState, useEffect } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const RoleEdit = (props: any) => {
    const apiId = 'role';
    const [form] = Form.useForm(); //form 
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [userId, setUserId] = useState('');
    const [brandData, setBrandData] = useState<any>();
    const [roleGroupData, setRoleGroupData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(
            defaultService,
            {
                query: {
                    apiId: 'brand',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setBrandData(res.data)
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'roleGroup',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setRoleGroupData(res.data)
                }
            })
        setUserId(localStorage.getItem('userId')!);
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        displayOptions: {
            width: 800
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={12}>
                    <Form.Item
                        label="ID"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="角色名称"
                        name="roleName"
                        rules={[{ required: true, message: '请输入角色名称!' }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="角色组"
                        name="roleGroupId" >
                        <Select
                            showSearch
                            placeholder="用户组"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(roleGroupData, { itemName: 'roleGroupName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="品牌"
                        name="brandId">
                        <Select
                            showSearch
                            placeholder="选择品牌"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                            {getList.general(brandData, { itemName: 'brandName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item
                        label="创建"
                        name="createdAtUserId"
                        initialValue={userId}>
                        <Input disabled={true} />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item
                        label="排序"
                        name="sort">
                        <InputNumber />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>
            </Row>)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default RoleEdit;